// Signature recipients routes
export default [
  {
    path: 'signature-recipients',
    name: 'signatureRecipients',
    redirect: 'signature-recipients/index',
    component: () =>
      import(
        /* webpackChunkName: "signatureRecipients" */ '../views/signatureRecipients/SignatureRecipients.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'signatureRecipientsIndex',
        meta: {
          tabbable: true,
          tableKeys: ['signatureRecipients'],
          filterKeys: [],
          formKeys: [],
          routePermissions: ['signatureManage'],
        },
        component: () =>
          import(
            /* webpackChunkName: "signatureRecipientsIndex" */ '../views/signatureRecipients/SignatureRecipientsIndex.vue'
          ),
      },
      {
        path: ':recipientGroupId',
        name: 'signatureRecipientsEdit',
        meta: {
          menuActiveRouteName: 'signatureRecipientsIndex',
          routePermissions: ['signatureManage'],
        },
        component: () =>
          import(
            /* webpackChunkName: "signatureRecipientsIndex" */ '../views/signatureRecipients/SignatureRecipientsIndex.vue'
          ),
      },
    ],
  },
];
